export interface WorkingModeBullet {
  bold?: string
  text: string
}

export interface WorkingModeOption {
  key: string
  badge: string
  title: string
}

export interface WorkingModeRow {
  label: string
  option1: WorkingModeBullet[]
  option2: WorkingModeBullet[]
}

export const workingModeOptions: WorkingModeOption[] = [
  { key: 'option1', badge: 'Option 1', title: 'Async Exploration with Moment of Fusion' },
  { key: 'option2', badge: 'Option 2', title: 'End-to-End Co-Creation' },
]

export const workingModeRows: WorkingModeRow[] = [
  {
    label: 'Style:',
    option1: [
      { bold: 'Mostly independent workstreams', text: ' with a final fusion moment.' },
      { bold: 'SMEs of each workstream', text: ' connect 1:1 to share input/commonalities before final sprint' },
    ],
    option2: [{ bold: 'Fully collaborative sprint sessions', text: '' }],
  },
  {
    label: 'Timeline:',
    option1: [
      { bold: '4-8 weeks', text: ' pre-work: depending on new research needs' },
      { bold: '2-day alignment', text: ' sprint at the end' },
    ],
    option2: [
      { bold: '4-8 weeks', text: ' pre-work: depending on new research needs' },
      { bold: '1 full week of co-creation sprinting', text: '' },
    ],
  },
  {
    label: 'Team Setup:',
    option1: [
      { bold: 'SMEs and partners', text: ' work mostly independently for each of the 3 workstreams' },
      { bold: '~70% of work done', text: ' asynchronously' },
      { bold: 'Team unites', text: ' for final consolidation sprint' },
    ],
    option2: [
      { bold: 'Core team carries out prework', text: '' },
      { bold: 'Actual BVA work', text: ' conducted by an entire cross-functional team during the sprint' },
      { bold: 'All 3 workstreams progress', text: ' simultaneously' },
    ],
  },
  {
    label: 'Best For:',
    option1: [
      { bold: 'Refresh', text: '' },
      { bold: 'Strong external', text: ' partner network' },
      { bold: 'Geographically dispersed teams', text: '' },
    ],
    option2: [
      { bold: 'Redo/ heavy refresh', text: '' },
      { bold: 'Dedicated team availability', text: '' },
      { bold: 'Preference for real-time collaboration', text: '' },
    ],
  },
]
